export function isValidPostcode(postcode) {

    if(!postcode) {
        return {
            isValid: false,
            errorMessage: "Postcode is required."
        }
    }

    const postcodeRegex = /^([GIR]0AA)|((([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9][A-Z]?))))[0-9][A-Z]{2})$/

    // Remove spaces from postcode
    const postcodeLookupResult = postcode.replace(/\s+/g, "").toUpperCase()

    // Validate length
    if (postcodeLookupResult.length < 5 || postcodeLookupResult.length > 8) {
        return {
            isValid: false,
            errorMessage: "Postcode should be between 5 and 8 characters long."
        }
    }

    // Check for invalid characters
    if (/[^A-Za-z0-9_.]/.test(postcodeLookupResult)) {
        return {
            isValid: false,
            errorMessage: "Postcode contains invalid characters. Only letters and numbers are allowed."
        }
    }

    // Check against UK postcode regex pattern
    if (!postcodeRegex.test(postcodeLookupResult)) {
        return {
            isValid: false,
            errorMessage: "Invalid postcode format. Make sure letters and numbers are in the correct positions."
        }
    }

    return {
        isValid: true,
        errorMessage: ""
    }
}
